import styled from 'styled-components'
import { deviceMax } from '../../theme/breakpoints'
import pxToRem from '../../utils/pxToRem'
import Button from '../Button/Button'

export const StyledProductsList = styled.div`
  z-index: 4;
  left: 0;
  right: 0;
  left: 0;
  top: ${({ isOurProducts }) => (isOurProducts ? pxToRem(80) : pxToRem(60))};
  position: absolute;
  flex-direction: column;
  align-items: flex-start;
  display: flex;
  padding: ${pxToRem(15)} ${pxToRem(45)};
  border-radius: 0 0 ${pxToRem(20)} ${pxToRem(20)};
  border: ${pxToRem(1)} solid ${({ theme }) => theme.colors.secondary.grey95};
  background-color: ${({ theme }) => theme.colors.unique.white};
  @media ${deviceMax.mobileL} {
    top: ${({ isOurProducts }) =>
      isOurProducts ? pxToRem(200) : pxToRem(180)};
  }
`

export const StyledButton = styled(Button)`
  margin: ${pxToRem(15)} 0;
  text-align: start;
`

export const StyledMessage = styled.p`
  margin: ${pxToRem(15)} ${pxToRem(4)};
  padding: ${pxToRem(5)} 0;
`
